(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initOffers(root) {
    if (!root || root.dataset.croReady === 'true') return;
    root.dataset.croReady = 'true';

    var viewport = root.querySelector('[data-cro-viewport]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cro-slide]'));
    if (!viewport || !cards.length) return;

    var prev = root.querySelector('[data-cro-prev]');
    var next = root.querySelector('[data-cro-next]');
    var dotsWrap = root.querySelector('[data-cro-dots]');
    var autoplay = parseInt(root.dataset.autoplay || '0', 10);
    var timer = null;
    var ticking = false;

    function targetLeft(index) {
      var card = cards[index];
      return card ? card.offsetLeft - viewport.offsetLeft : 0;
    }

    function currentIndex() {
      var left = viewport.scrollLeft;
      var best = 0;
      var distance = Infinity;
      cards.forEach(function (card, i) {
        var d = Math.abs(targetLeft(i) - left);
        if (d < distance) {
          distance = d;
          best = i;
        }
      });
      return best;
    }

    function updateDots() {
      if (!dotsWrap) return;
      var index = currentIndex();
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function go(index) {
      if (!cards.length) return;
      var nextIndex = (index + cards.length) % cards.length;
      viewport.scrollTo({ left: targetLeft(nextIndex), behavior: 'smooth' });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (autoplay >= 2000 && cards.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(function () {
          var nextIndex = currentIndex() + 1;
          if (nextIndex >= cards.length) nextIndex = 0;
          go(nextIndex);
        }, autoplay);
      }
    }

    if (dotsWrap && cards.length > 1) {
      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cro-offers__dot';
        dot.setAttribute('aria-label', 'Show offer ' + (i + 1));
        dot.addEventListener('click', function () {
          go(i);
          start();
        });
        dotsWrap.appendChild(dot);
      });
    }

    if (prev) prev.addEventListener('click', function () {
      go(currentIndex() - 1);
      start();
    });

    if (next) next.addEventListener('click', function () {
      go(currentIndex() + 1);
      start();
    });

    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateDots();
        ticking = false;
      });
    }, { passive: true });

    viewport.addEventListener('mouseenter', stop);
    viewport.addEventListener('mouseleave', start);
    viewport.addEventListener('focusin', stop);
    viewport.addEventListener('focusout', start);
    viewport.addEventListener('touchstart', stop, { passive: true });
    viewport.addEventListener('touchend', start, { passive: true });

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cro-copy]');
      if (!button) return;
      var code = button.getAttribute('data-cro-copy');
      if (!code || !navigator.clipboard) return;
      navigator.clipboard.writeText(code).then(function () {
        var feedback = button.querySelector('em, small');
        if (!feedback) return;
        var original = feedback.textContent;
        feedback.textContent = 'Copied';
        window.setTimeout(function () { feedback.textContent = original; }, 1400);
      }).catch(function () {});
    });

    updateDots();
    start();
  }

  function initCountdown(root) {
    if (!root || root.dataset.croReady === 'true') return;
    root.dataset.croReady = 'true';
    var daily = root.dataset.daily === 'true';
    var utcOffsetMinutes = parseInt(root.dataset.utcOffset || '330', 10);

    // Daily mode: next 23:59:59 in the store's time zone (UTC offset in minutes)
    function nextDailyEnd() {
      var offsetMs = utcOffsetMinutes * 60000;
      var storeNow = new Date(Date.now() + offsetMs);
      var storeEnd = Date.UTC(storeNow.getUTCFullYear(), storeNow.getUTCMonth(), storeNow.getUTCDate(), 23, 59, 59);
      return new Date(storeEnd - offsetMs);
    }

    var end = daily ? nextDailyEnd() : new Date(root.dataset.endAt);
    if (Number.isNaN(end.getTime())) {
      root.hidden = true;
      return;
    }

    var days = root.querySelector('[data-cro-days]');
    var hours = root.querySelector('[data-cro-hours]');
    var minutes = root.querySelector('[data-cro-minutes]');
    var seconds = root.querySelector('[data-cro-seconds]');
    var timer = null;

    function tick() {
      var distance = end.getTime() - Date.now();
      if (distance <= 0 && daily) {
        end = new Date(nextDailyEnd().getTime() + (distance > -1000 ? 1000 : 0));
        distance = end.getTime() - Date.now();
      }
      if (distance <= 0) {
        if (timer) window.clearInterval(timer);
        var expired = root.dataset.expiredText || '';
        if (expired) {
          root.innerHTML = '<div class="cro-countdown__copy"><span>' + expired.replace(/[&<>"']/g, function (c) {
            return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
          }) + '</span></div>';
        } else {
          root.hidden = true;
        }
        return;
      }
      var totalSeconds = Math.floor(distance / 1000);
      var d = Math.floor(totalSeconds / 86400);
      var h = Math.floor((totalSeconds % 86400) / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;
      if (days) days.textContent = pad(d);
      if (hours) hours.textContent = pad(h);
      if (minutes) minutes.textContent = pad(m);
      if (seconds) seconds.textContent = pad(s);
    }

    tick();
    timer = window.setInterval(tick, 1000);
  }

  function addDays(date, days) {
    var next = new Date(date);
    next.setDate(next.getDate() + Number(days || 0));
    return next;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' }).format(date);
  }

  function formatRange(start, end) {
    var a = formatDate(start);
    var b = formatDate(end);
    return a === b ? a : a + ' - ' + b;
  }

  function initDelivery(root) {
    if (!root || root.dataset.croReady === 'true') return;
    root.dataset.croReady = 'true';

    var today = new Date();
    today.setHours(12, 0, 0, 0);

    var readyMin = Number(root.dataset.readyMin || 0);
    var readyMax = Number(root.dataset.readyMax || readyMin);
    var deliveryMin = Number(root.dataset.deliveryMin || 0);
    var deliveryMax = Number(root.dataset.deliveryMax || deliveryMin);

    if (readyMax < readyMin) readyMax = readyMin;
    if (deliveryMax < deliveryMin) deliveryMax = deliveryMin;

    var ordered = root.querySelector('[data-cro-ordered-date]');
    var ready = root.querySelector('[data-cro-ready-date]');
    var delivered = root.querySelector('[data-cro-delivered-date]');

    if (ordered) ordered.textContent = formatDate(today);
    if (ready) ready.textContent = formatRange(addDays(today, readyMin), addDays(today, readyMax));
    if (delivered) delivered.textContent = formatRange(addDays(today, deliveryMin), addDays(today, deliveryMax));
  }

  function initAll(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-cro-offers]'), initOffers);
    Array.prototype.forEach.call(root.querySelectorAll('[data-cro-countdown]'), initCountdown);
    Array.prototype.forEach.call(root.querySelectorAll('[data-cro-delivery]'), initDelivery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();